"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var CosPageSelector =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(CosPageSelector, _PureComponent);
  (0, _createClass2.default)(CosPageSelector, null, [{
    key: "propTypes",
    get: function get() {
      return {
        updateDyno: _react.PropTypes.func.isRequired,
        redirectUrl: _react.PropTypes.string
      };
    }
  }]);

  function CosPageSelector(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CosPageSelector);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CosPageSelector).call(this, props));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(CosPageSelector, [{
    key: "handleChange",
    value: function handleChange(_ref) {
      var value = _ref.target.value;
      this.props.updateDyno({
        redirectUrl: value.options.url
      });
    }
  }, {
    key: "getPages",
    value: function getPages(input, callback) {
      _apiClient.default.get('content/api/v4/content-search/all', {
        query: {
          limit: 30,
          q: input
        }
      }).then(function (response) {
        var options = response.map(function (item) {
          return {
            text: item.name,
            help: item.url,
            options: {
              contentId: item.id,
              label: item.name,
              url: item.url
            },
            value: item.url
          };
        });
        callback(null, {
          options: options
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var url = this.props.redirectUrl;
      var value = null;

      if (url) {
        value = {
          text: url,
          options: {
            label: url,
            url: url
          },
          value: url
        };
      }

      return _react.default.createElement(_UISelect.default, {
        className: "cos-page-selector",
        name: "redirectUrl",
        defaultValue: value,
        loadOptions: this.getPages,
        multi: false,
        onSelectedOptionChange: this.handleChange,
        placeholder: _I18n.default.text('leadFlowEditor.leadFlowThankYouMessage.cosPlaceholder'),
        searchable: true,
        required: true
      });
    }
  }]);
  return CosPageSelector;
}(_react.PureComponent);

exports.default = CosPageSelector;
module.exports = exports.default;